module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh":{"searchPlaceholder":"자산 검색.."},"kr":{"searchPlaceholder":"搜索资产.."}}')
  delete Component.options._Ctor
}
